<template>
  <el-dialog class="store-dialog" title="选择店铺" :visible.sync="showDialog" :close-on-click-modal="false" :before-close="cancelAction">

    <div style="margin-bottom: 15px;">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-select @change="tag_search" v-model="value" placeholder="店铺标签">
            <el-option
              v-for="item in distributor_tags"
              :key="item.tag_id"
              :label="item.tag_name"
              :value="item.tag_id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <el-cascader placeholder="所属大区" @change="handleOfficeChange"
                       :options="new_office_area"
                       :props="{ checkStrictly: true }"
                       v-model="selected_office_area_id"
                       clearable>
          </el-cascader>
        </el-col>
        <el-col :span="8">
          <el-input placeholder="输入店铺英科ID" v-model="number" clearable><el-button slot="append" icon="el-icon-search" @click="handleIconClick"></el-button></el-input>
        </el-col>
        <el-col :span="8">
          <el-input placeholder="输入店铺名称" v-model="name" clearable><el-button slot="append" icon="el-icon-search" @click="handleIconClick"></el-button></el-input>
        </el-col>
      </el-row>
    </div>
    <el-table ref="multipleTable" :data="storeData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" v-loading="loading" :row-key="getRowKeys">
      <el-table-column type="selection" :reserve-selection="true" width="50"></el-table-column>
      <el-table-column prop="name" label="店铺名称"></el-table-column>
      <el-table-column prop="number" label="店铺英科ID"></el-table-column>
      <el-table-column prop="contact" label="联系人"></el-table-column>
      <el-table-column prop="store_name" label="门店"></el-table-column>
      <el-table-column prop="address" label="地址" show-overflow-tooltip></el-table-column>
    </el-table>
    <div v-if="total_count > params.pageSize" class="tr">
          <el-pagination
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :total="total_count" :page-size="pageLimit">
          </el-pagination>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelAction">取 消</el-button>
      <el-button type="primary" @click="saveStoreAction">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {getDistributorList, getOfficeArea} from '@/api/marketing'
// import office_area from '../../common/office_area.json'
import {getAreaManageList} from "../../api/areamanage";
export default {
  props: {
    relDataIds: {
      type: Array,
      default: function(){
        return []
      }
    },
    getStatus: {
      type: Boolean,
      default: false
    },
    isValid: {
      type: Boolean,
      default: false
    },
    storeVisible: {
      type: Boolean,
      default: false
    },
    sourceType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      dataType: 'distributor',
      loading: false,
      storeData: [],
      multipleSelection: [],
      pageLimit: 10,
      total_count: '',
      tag_id: '',
      params: {
        page: 1,
        pageSize: 10,
        // is_valid: 'true'
      },
      name: '',
      number:'',
      distributor_tags: [],
      selected_office_area_id:[],
      new_office_area:[],
      office_area_id:'',
      office_area_pid:'',
      value:''
    }
  },
  mounted () {
      this.getOfficeArea();
  },
  methods: {
    getOfficeArea(){
      getOfficeArea({'format_flag':true}).then(response => {
        this.new_office_area=response.data.data;
      })
    },
    tag_search(tag_id) {
      console.log(tag_id)
      this.params.tag_id = tag_id
      this.getDistributor()
    },
    // 大区名 和 id 对应
    handleOfficeChange:function (val){
      var now_office_area_pid = val[0]
      this.selected_office_area_id[0] = now_office_area_pid;
      if(val.length > 1){
        var now_office_area_id = val[1]
        this.selected_office_area_id[1] = now_office_area_id
      }else{
        var now_office_area_id = 0
      }
      this.office_area_id = now_office_area_id
      this.office_area_pid = now_office_area_pid
      this.params.office_area_id = now_office_area_id
      this.params.office_area_pid = now_office_area_pid
      this.getDistributor();
    },
    getDistributor() {
      getDistributorList(this.params).then( response => {
        this.storeData = response.data.data.list
        this.total_count = parseInt(response.data.data.total_count)
        this.loading = false
        this.multipleSelection = []
        this.distributor_tags = response.data.data.distributor_tags
        this.$refs.multipleTable.clearSelection()
        if (this.selectRows) {
          this.selectRows.forEach(item => {
            this.$refs.multipleTable.toggleRowSelection(item)
          })
        }
      })
    },
    getRowKeys (row) {
        return row.distributor_id
    },
    handleCurrentChange (page_num) {
      this.params.page = page_num
      this.getDistributor()
    },
    handleIconClick () {
      this.params.number = this.number
      this.params.name = this.name
      this.getDistributor()
    },
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      if (val) {
        this.multipleSelection= val
        val.forEach(item => {
          let isInArr = this.selectRows.findIndex((n) => n.distributor_id == item.distributor_id)
          if (isInArr == -1) {
            this.selectRows.push(item)
          }
        })
      }
    },
    cancelAction () {
      this.$emit('closeStoreDialog')
    },
    saveStoreAction () {
      this.$emit('chooseStore', this.multipleSelection)
    }
  },
  computed: {
    showDialog () {
      return this.storeVisible
    }
  },
  watch: {
    sourceType (newVal, oldVal) {
      this.dataType = this.sourceType
    },
    relDataIds (newVal, oldVal){
      this.selectRows = newVal
    },
    getStatus (newVal, oldVal) {
      this.getDistributor()
    },
  }
}
</script>

<style type="text/css">
  .store-dialog .el-checkbox {
    display: inline;
  }
</style>



// WEBPACK FOOTER //
// distributorSelect.vue?25ae11fd